import React from 'react'
import useLeaseSearch from './hooks/useLeaseSearch'
import { ILease } from '@api'
import { SearchDropdown } from '@ui'
import { Lease } from './TableView'
import track from '@track'
import { NavigateFn } from '@reach/router'

export default function LeaseSearch({
  navigate,
  queryTable,
}: {
  navigate?: NavigateFn
  queryTable: (query: string) => void
}) {
  const search = useLeaseSearch()
  const onSelect = (lease: ILease) => {
    navigate && navigate(`/leases?leaseId=${lease.id}`)
    track.lease({
      eventName: track.Event.SEARCH_RESULT_CLICK,
    })
  }

  return (
    <SearchDropdown
      {...{
        search,
        queryTable,
        onSelect,
        width: '400px',
      }}
      renderItem={(lease: ILease) => <Lease lease={lease} />}
    />
  )
}
